import api from './api';

const AREA_SCALAR_FIELDS = [
  'name',
  'project',
  'vert_responsible',
  'adi_responsible',
  'matricula_status',
  'total_area',
  'legal_reserve_area',
  'reserve_legal_status',
  'georeferencing_status',
  'sicar_code',
  'status_car',
];

const appendIfPresent = (formData, key, value) => {
  if (value === undefined || value === null || value === '') return;
  formData.append(key, value);
};

const appendIdList = (formData, key, ids) => {
  if (!Array.isArray(ids)) return;
  ids.forEach((id) => {
    if (id !== undefined && id !== null && id !== '') {
      formData.append(key, String(id));
    }
  });
};

export const guardianAreaService = {
  getGuardianAreas: async (filters = {}) => {
    try {
      const response = await api.get('/guardian/list_areas/', { params: filters });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getGuardianAreaById: async (id_code, filters = {}) => {
    try {
      const response = await api.get(`/guardian/view_area/${id_code}/`, { params: filters });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getGuardianAreaHistory: async (id_code) => {
    try {
      const response = await api.get(`/guardian/area_history/uuid:${id_code}/`);
      return response.data;
    } catch (error) {
      console.error(`❌ Erro ao buscar histórico da área ${id_code}:`, error);
      throw error;
    }
  },

  getFilterGuardianAreas: async (column, search) => {
    try {
      const response = await api.get('/guardian/filter_areas/', {
        params: {
          column,
          search,
        },
      });
      return response.data;
    } catch (error) {
      console.error(`❌ Erro ao filtrar áreas (coluna: ${column}, busca: ${search}):`, error);
      throw error;
    }
  },

   getArchivedGuardianAreas: async () => {
    try {
      const response = await api.get('/guardian/archived-areas/');
      return response.data;
    } catch (error) {
      console.error("❌ Erro ao buscar áreas arquivadas:", error);
      throw error;
    }
  },

  archiveGuardianArea: async (id_code) => {
    try {
      const response = await api.patch(`/guardian/archive_area/${id_code}/`, {
        archived: true
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createGuardianArea: async (payload) => {
    try {
      const formData = new FormData();

      AREA_SCALAR_FIELDS.forEach((field) => {
        appendIfPresent(formData, field, payload[field]);
      });

      appendIdList(formData, 'other_responsibles', payload.other_responsibles);
      appendIdList(formData, 'vert_responsibles', payload.vert_responsibles);

      if (payload.adi_image instanceof File) {
        formData.append('adi_image', payload.adi_image);
      }

      const response = await api.post('/guardian/create_area/', formData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateGuardianArea: async (id_code, payload, edit_reason) => {
    try {
      const formDataToSend = new FormData();
      formDataToSend.append(
        'edit_reason',
        edit_reason || 'Edição sem motivo informado'
      );

      AREA_SCALAR_FIELDS.forEach((field) => {
        // project costuma não mudar na edição; só envia se veio no payload
        if (field === 'project' && (payload.project === undefined || payload.project === null || payload.project === '')) {
          return;
        }
        appendIfPresent(formDataToSend, field, payload[field]);
      });

      if (Array.isArray(payload.other_responsibles)) {
        appendIdList(formDataToSend, 'other_responsibles', payload.other_responsibles);
      }

      if (Array.isArray(payload.vert_responsibles)) {
        appendIdList(formDataToSend, 'vert_responsibles', payload.vert_responsibles);
      }

      if (payload.adi_image instanceof File) {
        formDataToSend.append('adi_image', payload.adi_image);
      } else if (payload.remove_adi_image) {
        formDataToSend.append('remove_adi_image', 'true');
      }

      const response = await api.patch(
        `/guardian/update_area/${id_code}/`,
        formDataToSend
      );

      return response.data;
    } catch (error) {
      console.error(`❌ Erro no serviço updateGuardianArea para ${id_code}:`, error);
      console.error('📋 Detalhes do erro:', error.response?.data);
      throw error;
    }
  },

  deleteGuardianArea: async (id_code) => {
    try {
      const response = await api.delete(`/guardian/delete_area/${id_code}/`);
      return response.data;
    } catch (error) {
      console.error(`❌ Erro ao deletar área ${id_code}:`, error);
      console.error('📋 Detalhes do erro:', error.response?.data);
      throw error;
    }
  },
};
